// components/I18NProvider.tsx
"use client";
import { I18nextProvider } from "react-i18next";
import { useState } from "react";
import { createInstance, type Resource } from "i18next";
import { initReactI18next } from "react-i18next/initReactI18next";
import { i18nConfig } from "@/lib/i18n";

type Props = {
  children: React.ReactNode;
  locale: string;
  namespaces: string[];
  resources: Resource;
};

export default function I18NProvider({
  children,
  locale,
  namespaces,
  resources,
}: Props) {
  const [i18nInstance] = useState(() => {
    const instance = createInstance();
    instance.use(initReactI18next);
    instance.init({
      lng: locale,
      fallbackLng: i18nConfig.defaultLocale,
      resources,
      ns: namespaces,
      interpolation: { escapeValue: false },
      supportedLngs: i18nConfig.locales,
      preload: i18nConfig.locales,
    });
    return instance;
  });

  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
}
